$ ->
  Groupon.DFPAds ||= {}

  Groupon.DFPAds.showAds = ->
    $('.dfp-footer').map(->
      @id
    ).each (i, id) ->
      googletag.cmd.push ->
        googletag.display id

$(window).load ->
  Groupon.DFPAds?.showAds?()
